import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarCodeService } from './barcode.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [BarCodeService],
})
export class BarcodeModule {}
